import { withUnmountTransition } from '../../../misc/withUnmountTransition.hoc'

import { SearchDrug } from './SearchDrug.component'

const withUnmountHoc = withUnmountTransition(SearchDrug)
export { withUnmountHoc as SearchDrug }
